import { render, staticRenderFns } from "./FinishedRecords.vue?vue&type=template&id=1ab44304&"
import script from "./FinishedRecords.vue?vue&type=script&lang=js&"
export * from "./FinishedRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports